import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { slider } from "./components/slider";
import { inputError } from "./components/inputError";
import { megaMenu } from "./components/megaMenu";
import { pageTop } from "./components/pageTop";



$(document).ready(function () {

  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".u-anime";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "fadeIn";
    scrollAnime(animeEl, addAnimeClass);

  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = ".l-header__menu";
    //ハンバーガーメニュークラス定義
    const menuEl = ".l-header--nav";
    const closeEl = ".l-header--nav__close";
    humbergerMenuButton(buttonEl, menuEl, closeEl);

  })();

  (() => {
    /*
    スライダー用関数
    */
    const sliderEl = ".swiper";
    slider(sliderEl);
  })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".accordion";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".accordionItem";
    accordion(accordionEl, accordionButtonEl, accordionItemEl);
  })();

  (() => {
    /*
    タブ用関数
    */
    //タブボタンラッパークラス定義
    const tabButtonEl = ".tabButton";
    //タブコンテンツラッパークラス定義
    const tabContentsEl = ".tabContent";
    tab(tabButtonEl, tabContentsEl);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = "#megaMenu";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".megaMenuItem";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".megaMenuContents";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    //フォームラッパークラス定義
    const formEl = ".p-form";
    //エラー表示用クラス定義
    const addErrorClass = "c-error";
    //WPなどでフォームから出力されるエラークラスを定義
    const errorEl = "error";
    inputError(formEl, addErrorClass, errorEl);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const pageTopButtonEl = "#pageTop";
    //初期状態を定義
    const hide = true;
    pageTop(pageTopButtonEl, hide);
  })();

});
$(function () {
 var headerHight = 60; //ヘッダの高さ
 $('a[href^=#]').click(function(){
     var href= $(this).attr("href");
       var target = $(href == "#" || href == "" ? 'html' : href);
        var position = target.offset().top-headerHight; //ヘッダの高さ分位置をずらす
     $("html, body").animate({scrollTop:position}, 550, "swing");
        return false;
   });
});
